


// import React from "react";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   return (
//     <footer className="bg-black text-white py-12 px-4">
//       <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
//         {/* Column 1 */}
//         <div className="text-center">
//           <img src="/images/footer/logo.png" alt="İstanbul Temizlik Servisi" className="mb-4 h-10 mx-auto" />
//           <ul className="space-y-6">
//             <li><Link to="/hali-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">HALI YIKAMA</Link></li>
//             <li><Link to="/koltuk-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">KOLTUK YIKAMA</Link></li>
//             <li><Link to="/yatak-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">YATAK YIKAMA</Link></li>
//             <li><Link to="/yorgan-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">YORGAN YIKAMA</Link></li>
//             <li><Link to="/stor-zebra-perde-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">PERDE YIKAMA</Link></li>
//             <li><Link to="/yerinde-yikama" className="flex items-center gap-2 justify-center underline underline-offset-8">YERİNDE YIKAMA</Link></li>
//             <li><Link to="/hali-tamir-overlok" className="flex items-center gap-2 justify-center underline underline-offset-8">HALI TAMİR - OVERLOK</Link></li>
//             <li><Link to="/kuru-temizleme" className="flex items-center gap-2 justify-center underline underline-offset-8">KURU TEMİZLEME</Link></li>
//           </ul>
//         </div>

//         {/* Column 2 */}
//         <div className="text-center">
//           <img src="/images/footer/logo.png" alt="İstanbul Temizlik Servisi" className="mb-4 h-10 mx-auto" />
//           <ul className="space-y-6">
//             <li><Link to="/" className="block underline underline-offset-8">ANA MENÜ</Link></li>
//             <li><Link to="/kurumsal" className="block underline underline-offset-8">KURUMSAL MENÜ</Link></li>
//             <li><Link to="/bolgeler" className="block underline underline-offset-8">HİZMET BÖLGELERİ</Link></li>
//             <li><Link to="/galeri/tum-galeri" className="block underline underline-offset-8">GALERİ</Link></li>
//             <li><Link to="/blog" className="block underline underline-offset-8">BLOG</Link></li>
//             {/* <li><Link to="/iletisim" className="block underline underline-offset-8">İLETİŞİM</Link></li> */}
//           </ul>
//         </div>

//         {/* Column 3 */}
//         <div className="text-center space-y-6">
//           <img src="/images/footer/callcenter.png" alt="Destek" className="h-20 mx-auto" />
//           <div>
//             <h4 className="font-semibold underline underline-offset-8">ÇAĞRI MERKEZİ</h4>
//             <p>0 (535) 735 10 42</p>
//           </div>
//           <div className="flex justify-center gap-4 mt-2">
//             <a href="https://wa.me/905015335060" target="_blank" rel="noopener noreferrer">
//               <img src="/images/footer/whatsapp.png" className="w-6" alt="WhatsApp" />
//             </a>
//             <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
//               <img src="/images/footer/facebook.png" className="w-6" alt="Facebook" />
//             </a>
//             <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
//               <img src="/images/footer/instagram.png" className="w-6" alt="Instagram" />
//             </a>
//           </div>
//           <div className="flex justify-center mt-4">
//             <img src="/images/footer/magaza.png" alt="Mağaza" className="w-48 rounded" />
//           </div>
//         </div>
//       </div>

//       <div className="text-center text-sm text-gray-400 mt-8">
//         <p>© 2015 İstanbul Temizlik Servisi. Tüm hakları saklıdır.</p>
//         <p className="mt-1">
//           Web tasarım:{" "}
//           <a href="https://boldsoftware.com.tr" target="_blank" rel="noopener noreferrer" className="underline underline-offset-8">
//             BoldSoft
//           </a>
//         </p>
//         <div className="mt-2">
//           <img src="/images/footer/boldsoftlogo.png" alt="BoldSoft" className="h-6 mx-auto" />
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
import React from "react";
import { Link } from "react-router-dom";
import {
  PhoneCall,
  MapPin,
  Clock3,
  MessageCircle,
  Instagram,
  Facebook,
  ArrowRight,
 
} from "lucide-react";

const serviceLinks = [
  { label: "Halı Yıkama", path: "/hali-yikama" },
  { label: "Koltuk Yıkama", path: "/koltuk-yikama" },
  { label: "Yatak Yıkama", path: "/yatak-yikama" },
  { label: "Yorgan Yıkama", path: "/yorgan-yikama" },
  { label: "Perde Yıkama", path: "/stor-zebra-perde-yikama" },
  { label: "Yerinde Yıkama", path: "/yerinde-yikama" },
  { label: "Halı Tamir - Overlok", path: "/hali-tamir-overlok" },
  { label: "Kuru Temizleme", path: "/kuru-temizleme" },
];

const menuLinks = [
  { label: "Ana Menü", path: "/" },
  { label: "Kurumsal Menü", path: "/kurumsal" },
  { label: "Hizmet Bölgeleri", path: "/bolgeler" },
  { label: "Galeri", path: "/galeri/tum-galeri" },
  { label: "Blog", path: "/blog" },
];

// const features = [
//   {
//     icon: <ShieldCheck size={17} />,
//     text: "Güvenilir Hijyen",
//   },
//   {
//     icon: <Truck size={17} />,
//     text: "Ücretsiz Servis",
//   },
//   {
//     icon: <Sparkles size={17} />,
//     text: "Profesyonel Temizlik",
//   },
// ];

const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-[#000000] text-white">
      <div className="pointer-events-none absolute -top-24 right-0 h-80 w-80 rounded-full bg-white/20 blur-2xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-80 w-80 rounded-full bg-white/5 blur-3xl" />

      <div className="relative z-10 mx-auto max-w-screen-xl px-4 py-14 md:py-18">
        <div className="mb-12 rounded-[32px] border border-white/10 bg-white/[0.04] p-6 shadow-[0_20px_60px_rgba(0,0,0,0.18)] backdrop-blur-sm md:p-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:items-center">
            <div className="text-center md:text-left">
              <img
                src="/images/footer/logo1.png"
                alt="İstanbul Temizlik Servisi"
                className="mx-auto mb-5 h-12 object-contain md:mx-0"
              />

              <p className="text-sm leading-7 text-white/70">
                Halı, koltuk, perde, yorgan ve yerinde yıkama hizmetlerinde
                güvenilir, hijyenik ve profesyonel temizlik çözümleri sunuyoruz.
              </p>
            </div>

            {/* <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 md:col-span-2">
              {features.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-center gap-3 rounded-2xl border border-white/10 bg-white/[0.05] px-4 py-4 text-sm font-semibold text-white/90"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#C18A4A] text-white">
                    {item.icon}
                  </span>
                  {item.text}
                </div>
              ))}
            </div> */}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div>
            <h3 className="mb-5 text-lg font-black text-white">
              Hizmetlerimiz
            </h3>

            <ul className="space-y-3">
              {serviceLinks.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.path}
                    className="group flex items-center justify-between rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-sm font-medium text-white/75 transition-all duration-300 hover:border-[#C18A4A] hover:bg-[#C18A4A] hover:text-white"
                  >
                    {item.label}
                    <ArrowRight
                      size={15}
                      className="opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100"
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-5 text-lg font-black text-white">
              Menü
            </h3>

            <ul className="space-y-3">
              {menuLinks.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.path}
                    className="group flex items-center justify-between rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-sm font-medium text-white/75 transition-all duration-300 hover:border-[#C18A4A] hover:bg-white hover:text-[#081B2F]"
                  >
                    {item.label}
                    <ArrowRight
                      size={15}
                      className="opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100"
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-5 text-lg font-black text-white">
              İletişim
            </h3>

            <div className="space-y-4">
              <a
                href="tel:+905520933675"
                className="flex items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-4 transition-all duration-300 hover:border-[#C18A4A] hover:bg-white/[0.08]"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#C18A4A] text-white">
                  <PhoneCall size={18} />
                </span>

                <span>
                  <span className="block text-xs font-semibold uppercase tracking-[2px] text-white/50">
                    Çağrı Merkezi
                  </span>
                  <span className="mt-1 block text-lg font-black text-white">
                    0 (552) 093 36 75
                  </span>
                </span>
              </a>

              <div className="flex items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#C18A4A] text-white">
                  <Clock3 size={18} />
                </span>

                <span>
                  <span className="block text-xs font-semibold uppercase tracking-[2px] text-white/50">
                    Çalışma Saatleri
                  </span>
                  <span className="mt-1 block text-sm font-semibold text-white/85">
                    08:00 - 22:00
                  </span>
                </span>
              </div>

              <div className="flex items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#C18A4A] text-white">
                  <MapPin size={18} />
                </span>

                <span>
                  <span className="block text-xs font-semibold uppercase tracking-[2px] text-white/50">
                    Servis Bölgesi
                  </span>
                  <span className="mt-1 block text-sm font-semibold text-white/85">
                    İstanbul geneli ücretsiz servis
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="mb-5 text-lg font-black text-white">
              Bize Ulaşın
            </h3>

            <div className="rounded-[28px] border border-white/10 bg-white/[0.04] p-5">
              <img
                src="/images/footer/callcenter.png"
                alt="Destek"
                className="mx-auto mb-5 h-24 object-contain"
              />

              <p className="mb-5 text-center text-sm leading-7 text-white/70">
                Hızlı fiyat almak veya servis talebi oluşturmak için bizi
                arayabilir ya da WhatsApp üzerinden yazabilirsiniz.
              </p>

              <div className="grid grid-cols-3 gap-3">
                <a
                  href="https://wa.me/905520933675"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-12 items-center justify-center rounded-2xl bg-[#25D366] text-white transition-all duration-300 hover:-translate-y-1"
                  aria-label="WhatsApp"
                >
                  <MessageCircle size={20} />
                </a>

                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-12 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.06] text-white transition-all duration-300 hover:-translate-y-1 hover:bg-white hover:text-[#081B2F]"
                  aria-label="Facebook"
                >
                  <Facebook size={20} />
                </a>

                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-12 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.06] text-white transition-all duration-300 hover:-translate-y-1 hover:bg-white hover:text-[#081B2F]"
                  aria-label="Instagram"
                >
                  <Instagram size={20} />
                </a>
              </div>

              <div className="mt-5 overflow-hidden rounded-2xl border border-white/10 bg-white">
                <img
                  src="/images/footer/magaza.png"
                  alt="Mağaza"
                  className="h-auto w-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-7">
          <div className="flex flex-col items-center justify-between gap-5 text-center md:flex-row md:text-left">
            <p className="text-sm text-white/55">
              © 2015 İstanbul Temizlik Servisi. Tüm hakları saklıdır.
            </p>

           
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;